<template>
    <div class="mb-4">

        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-4 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-book-open mr-1"></i> Temas
                        </h5>
                    </div>
                    <div class="col-12 col-sm-8 text-left text-sm-right d-flex flex-column flex-sm-row gap-2 justify-content-end">

                        <a href="/teacher/themes/create" class="btn btn-primary  ml-sm-auto mr-auto mr-sm-0 mt-3 mt-sm-0">
                            Criar Tema
                        </a>
                        <button class="btn btn-outline-secondary position-relative mr-2" v-b-tooltip.hover title="Criar e editar categorias para os temas" @click="showTagManager">
                            Tags
                            <span class="position-absolute top-0 start-100  translate-middle badge rounded-pill bg-warning">
                                Novo
                              </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Container -->
        <div class="container">
            <!-- Filters -->
            <div class="row mb-2">
                <div class="col-sm-6">
                    <!-- Field -->
                    <b-form-group label="Título">
                        <b-form-input
                            v-model="filter.title"
                            placeholder="Buscar por título ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-6">
                    <!-- Field -->
                    <b-form-group label="Modo de Correção">
                        <multiselect
                            v-model="filter.mode_id"
                            :options="modes"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder="Buscar por Modo de Correção ..."
                            tag-placeholder="Filtrar Modo de Correção"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">
                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há modos de correção disponíveis para exibir :(
                            </span>
                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-6">
                    <!-- Field -->
                    <b-form-group label="Turma">
                        <multiselect
                            v-model="filter.group_id"
                            :options="groups"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder="Buscar por Turma ..."
                            tag-placeholder="Filtrar por Turma"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">
                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há turmas disponíveis para exibir :(
                            </span>
                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-6">
                    <!-- Field -->
                    <b-form-group
                        label="Tags">

                        <!-- Input -->
                        <multiselect
                            v-model="filter.tags"
                            :options="tagsOptions"
                            :multiple="true"
                            placeholder="Filtrar por Tag"
                            selectLabel="Filtrar por Tag"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há tags marcadas no momento.
                            </span>
                        </multiselect>
                    </b-form-group>
                </div>
            </div>

            <!-- Content -->
            <b-overlay :show="loading" rounded="sm">
                <div class="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-4">
                    <div class="col" v-for="theme in table" :key="theme.id">
                        <b-card-group
                            :img-alt="theme.title"
                            :img-src="theme.preview"
                            @click="show(theme.id)"
                            class="mb-4 link position-relative bg-white"
                        >   
                            <b-card-img :src="theme.preview"></b-card-img>
                            <div class="position-absolute pl-3 pt-1">
                                
                                <div class="bg-success badge text-white py-1 rounded" v-if="theme.avaliable_in === null || theme.avaliable_in && $moment().isSameOrAfter($moment(theme.avaliable_in), 'day') ">
                                    <div>Disponível</div>
                                </div>
                                <div v-else class="bg-info badge text-white py-1 rounded" style="background-color: #ffc10710">
                                    Disponível em {{ $moment(theme.avaliable_in).format('D/MM/YYYY') }}
                                </div>
                            </div>
                            <b-card-text class="p-3">

                                <div class="h4" v-b-tooltip.hover :title="theme.title">
                                    <span class="d-none d-sm-inline-block">
                                        {{ theme.title | truncate(46) }}
                                    </span>
                                    <span class="d-inline-block d-sm-none">
                                        {{ theme.title }}
                                    </span>
                                </div>
    
                                <dl>
                                    <dt>
                                        Modo de Correção
                                    </dt>
                                    <dd v-b-tooltip.hover :title="theme.mode.name">
                                        {{ theme.mode.name | truncate(35) }}
                                    </dd>
                                </dl>
    
                                <dl v-if="theme.author">
                                    <dt>
                                        Autor
                                    </dt>
                                    <dd v-b-tooltip.hover :title="theme.author.name">
                                        {{ theme.author.name | truncate(35) }}
                                    </dd>
                                </dl>
    
                                <dl >
                                    <dt>
                                        Turmas
                                    </dt>
                                    <dd v-if="theme.groups.length > 0">
                                        <span class="badge badge-secondary mr-1" v-for="group in theme.groups" :key="group.id" >
                                            {{ group.name }}
                                        </span>
                                    </dd>
                                    <dd class="text-muted" v-else>
                                        Nenhuma Turma Selecionada
                                    </dd>
                                </dl>
    
                                <dl >
                                    <dt>
                                        Tags
                                    </dt>
                                    <dd v-if="theme.tags.length > 0">
                                        <span class="badge badge-primary mr-1" v-for="(tag, tagIdx) in theme.tags" :key="tagIdx">
                                            {{ tag.name }}
                                        </span>
                                    </dd>
                                    <dd class="text-muted" v-else>
                                        Sem Tags
                                    </dd>
                                </dl>
    
                                <dl>
                                    <dt>
                                        Postado
                                    </dt>
                                    <dd>
                                        {{ theme.created_at | moment('from', 'now') }}
                                    </dd>
                                </dl>
    
                            </b-card-text>


                        </b-card-group>
                    </div>
                </div>
            </b-overlay>

            <!-- Empty -->
            <div v-if="table.length === 0 && !loading" class="bg-light p-4 text-center mb-3">
                Não encontramos nenhum resultado na busca :(
            </div>

            <!-- Paginate -->
            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                @change="changePagination"
            />

            <!-- Results -->
            <div class="mb-4">
                {{ total }} resultados encontrados.
            </div>
        </div>
        <tag-manager></tag-manager>

    </div>
</template>

<script>
import CreateButton from "./CreateButton";
import TagManager from "./TagManager.vue";

export default {
    components: {
        CreateButton,
        TagManager
    },
    props: ['endpointIndex', 'endpointIndexShared', 'endpointAttach', 'modes', 'groups', 'tags'],
    data() {
        return {
            loading: false,
            table: [],
            perPage: 12,
            currentPage: 1,
            total: 0,
            sortBy: 'created_at',
            sortDesc: true,
            fields: [],
            filter: {
                title: null,
                mode_id: null,
                group_id: null,
                tags: []
            },
            lastResultsCount: 5,
            tagsOptions: this.tags.map(tag => tag.name),
        }
    },
    created() {
        this.load()
    },
    watch: {
        'filter.title': async function (value) {
            this.filter.title = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.mode_id': async function (value) {
            this.filter.mode_id = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.group_id': async function (value) {
            this.filter.group_id = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.tags': async function (value) {
            this.filter.tags = await value;
            this.currentPage = 1
            await this.load()
        },
    },
    methods: {

        load() {
            this.loading = true;
            axios.get(this.endpointIndex, {
                params: {
                    title: this.filter.title,
                    mode_id: this.filter.mode_id ? this.filter.mode_id.id : null,
                    group_id: this.filter.group_id ? this.filter.group_id.id : null,
                    tags: this.filter.tags,

                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.themes.data
                    this.currentPage = response.themes.current_page
                    this.perPage = response.themes.per_page
                    this.total = response.themes.total

                    this.lastResultsCount = response.themes.data.length

                })
                .finally(() => this.loading = false)
        },

        async changePagination(page) {
            this.currentPage = await page;
            this.load()
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            this.load()
        },

        show(id) {
            window.location = '/teacher/themes/' + id
        },

        showTagManager(){
            this.$root.$emit('tagManager')
        }

    }
}
</script>

<style scoped>
    .link {
        cursor: pointer;
    }
    .link:hover {
        box-shadow: 0 4px 6px rgba(3,27,78,.1);
        background: #FDFDFD;
    }
    .card-img {
        height: 225px !important;
    }
</style>
